import { useEffect, useState } from "react";
import { strLang } from "../functions/strLang";
import { removeAccents } from "../functions/removeAccents";
import { updateCheck, updateUser } from "../services/territories";
import { colorsList } from "../data/colorsList";
import { tileList } from "../data/tilesList";
import { checkDate } from "../functions/checkDate";
import { checkHour } from "../functions/checkHour";
import { checkDay } from "../functions/checkDay";
import {
  saveWarningSeen,
  warningWasShowed,
} from "../functions/warningFunctions";
import { isEditor } from "../functions/isEditor";

var totalp = 0;

export default function useTerritories({
  maps = [],
  openMap,
  reloadMap,
  terGroups,
}) {
  const [open, setOpen] = useState(false);
  const [list, setList] = useState([]);
  const [selectedTer, setSelectedTer] = useState({ id: false, name: false });
  const [filter, setFilter] = useState({
    text: "",
    sort:
      Number(localStorage.getItem("ter_order")) < 1
        ? 1
        : Number(localStorage.getItem("ter_order")),
    status: 0,
    group: -1,
  });
  const [groupScreen, setGroupScreen] = useState(false);

  const closeMsg = () => {
    setOpen(false);
    setSelectedTer({ id: false, name: false });
  };

  const switchGroupScreen = () => setGroupScreen(!groupScreen);
  const closeGroupScreen = () => setGroupScreen(false);
  const clearText = () => filterMap({ text: "" });

  const funcUpdateCheck = async (type, o) => {
    setOpen("loading");
    const results = await updateCheck(type, o);
    if (results && results.status) {
      if (type === "HISTER") {
        return results.historial;
      } else {
        reloadMap();
      }
    }
    closeMsg();
  };

  const saveOrder = (index) => {
    closeMsg();
    if (filter.sort !== index) {
      localStorage.setItem("ter_order", index);
      changeOrder(index);
    } else if (groupScreen) {
      setGroupScreen(false);
    }
  };

  const startStatus = (index) => {
    closeMsg();
    if (filter.status !== index) {
      filterMap({ status: index });
    } else if (groupScreen) {
      setGroupScreen(false);
    }
  };

  useEffect(() => {
    if (maps) {
      totalp = 0;
      maps.forEach((o) => (totalp += o.TOTAL));

      changeOrder();
      closeMsg();
    }
  }, [maps]);

  const changeOrder = (newOrder = filter.sort) => {
    switch (newOrder) {
      case 2:
        maps.sort((a, b) => {
          return new Date(b.DATE) - new Date(a.DATE);
        });
        break;
      case 3:
        maps.sort((a, b) => {
          return new Date(a.DATE) - new Date(b.DATE);
        });
        break;
      default:
        maps.sort((a, b) => {
          if (a.NOM.toUpperCase() < b.NOM.toUpperCase()) {
            return -1;
          }
          if (a.NOM.toUpperCase() > b.NOM.toUpperCase()) {
            return 1;
          }
          return 0;
        });
        break;
    }
    filterMap({ text: filter.text, sort: newOrder });
  };

  const filterMap = (tempFilter) => {
    if (groupScreen) {
      setGroupScreen(false);
    }
    tempFilter = { ...filter, ...tempFilter };
    let isGroup = tempFilter.group > -1,
      noGroup = tempFilter.group === -2,
      withStatus = tempFilter.status > 0;
    setFilter({ ...filter, ...tempFilter });
    let txt =
      tempFilter.text !== ""
        ? removeAccents(tempFilter.text.trim()).toLowerCase()
        : "";
    let tempMap =
      isGroup || noGroup || withStatus || txt !== ""
        ? maps.filter((o) => {
            let nameOk =
              txt === ""
                ? true
                : removeAccents(o.NOM).toLowerCase().includes(txt);
            let groupOk =
              (isGroup && o.TERGROUP === terGroups[tempFilter.group].code) ||
              !isGroup;

            let noGroupOk =
              (noGroup && !terGroups.some((e) => e.code === o.TERGROUP)) ||
              !noGroup;
            let statusOk =
              (withStatus &&
                tempFilter.status ===
                  (!o.HECHOS ? 1 : o.HECHOS === o.TOTAL ? 3 : 2)) ||
              !withStatus;
            return nameOk && groupOk && noGroupOk && statusOk;
          })
        : maps;

    setList([
      {
        ID: "",
        NOM: `${strLang("group")}: ${
          isGroup ? terGroups[tempFilter.group].name : strLang("all")
        }`,
        TOTAL: tempMap.reduce((acc, cValue) => acc + cValue.TOTAL, 0),
      },
      ...tempMap,
    ]);
    if (open === "loading") {
      closeMsg();
    }
  };

  const askOpenTerritory = (id, name, descrip) => {
    if (id > 0) {
      setSelectedTer({ id, name, descrip });
      setOpen("openTer");
    } else if (isEditor) {
      setOpen("openAllTer");
    }
  };

  const askDelete = (id, name) => {
    setSelectedTer({ id, name });
    setOpen("delete");
  };

  const editTer = ({ id, name, tile, descrip, group }) => {
    tile = tile === "" ? "default" : tile;
    setSelectedTer({
      id,
      label: name,
      name,
      tile: {
        value: tile,
        label: strLang(tile, "tileNames"),
      },
      descrip,
      group: {
        value: group,
        label: terGroups.filter((e) => e.code === group)[0]?.name,
      },
      tryAgain: "editTer",
    });
    setOpen("editTer");
  };

  const updateTer = (values) => {
    setSelectedTer({ ...selectedTer, ...values });
  };

  const openWarningMsg = () => {
    saveWarningSeen(selectedTer.id);
    setOpen("openWarning");
  };

  const startMap = () => {
    openMap({ id: selectedTer.id, name: selectedTer.name, screen: "map" });
    updateUser(selectedTer.id);
    closeMsg();
  };

  const openRecords = async (id, name) => {
    const histData = await funcUpdateCheck("HISTER", { code: id });
    let recordData = [];
    if (histData && histData.length > 0) {
      recordData = histData.map((o, index) => {
        let theDate = o.FECHA.split(" ");
        return {
          bgColor:
            o.STA === 3
              ? colorsList.lightGreen
              : index % 2 === 0
              ? colorsList.lightGrey
              : colorsList.white,
          data: [
            checkDate(theDate[0]),
            checkHour(theDate[1] !== "00:00:00" ? theDate[1] : o.HORA),
            checkDay(theDate[0]),
            o.STA === 3 ? strLang("scheduled") : isEditor ? o.PER : " ",
          ],
        };
      });
    }
    setSelectedTer({ id, name, table: recordData });
    setOpen("records");
  };

  const openUpdateGroup = () => {
    setSelectedTer({ id: false, name: "", tryAgain: "editGroup" });
    setOpen("editGroup");
  };

  const updateGroupData = () => {
    if (selectedTer.name.trim() === "") {
      setOpen("nameEmpty");
    } else {
      funcUpdateCheck("HANDLEGROUP", {
        code: selectedTer.id,
        name: selectedTer.name.trim().replace('"', "ʺ"),
        group: localStorage.getItem("code"),
      });
    }
  };

  const deleteGroup = () => {
    if (selectedTer.id > 0) {
      funcUpdateCheck("DELETEGROUP", { code: selectedTer.id });
    }
  };

  const msgType = {
    sort: {
      label: strLang("sort"),
      btnColumn: true,
      buttons: [
        {
          label: "A > B",
          func: () => saveOrder(1),
          width: 80,
          color: filter.sort === 1 ? null : colorsList.darkGrey,
        },
        {
          label: strLang("mostRecent"),
          func: () => saveOrder(2),
          width: 80,
          color: filter.sort === 2 ? null : colorsList.darkGrey,
        },
        {
          label: strLang("mostOverdue"),
          func: () => saveOrder(3),
          width: 80,
          color: filter.sort === 3 ? null : colorsList.darkGrey,
        },
      ],
    },
    status: {
      label: strLang("status"),
      btnColumn: true,
      buttons: [
        {
          label: strLang("all"),
          func: () => startStatus(0),
          width: 80,
          color: filter.status === 0 ? null : colorsList.darkGrey,
        },
        {
          label: strLang("readyToStart"),
          func: () => startStatus(1),
          width: 80,
          color: filter.status === 1 ? null : colorsList.darkGrey,
        },
        {
          label: strLang("inProgress"),
          func: () => startStatus(2),
          width: 80,
          color: filter.status === 2 ? null : colorsList.darkGrey,
        },
        {
          label: strLang("finalized"),
          func: () => startStatus(3),
          width: 80,
          color: filter.status === 3 ? null : colorsList.darkGrey,
        },
      ],
    },
    openTer: {
      title: strLang("terAsk"),
      label: selectedTer.name,
      buttons: [
        {
          label: strLang("open"),
          func:
            !warningWasShowed(selectedTer.id) && selectedTer.descrip
              ? openWarningMsg
              : startMap,
          width: 80,
        },
        {
          label: strLang("cancel"),
          func: closeMsg,
          width: 80,
          color: colorsList.darkGrey,
        },
      ],
    },
    openAllTer: {
      title: strLang("allTerAsk"),
      buttons: [
        {
          label: strLang("open"),
          func: () => {
            openMap({ id: "all", name: "", screen: "map" });
            closeMsg();
          },
          width: 80,
        },
        {
          label: strLang("cancel"),
          func: closeMsg,
          width: 80,
          color: colorsList.darkGrey,
        },
      ],
    },
    editTer: {
      title: selectedTer.id ? selectedTer.label : strLang("newTer"),
      blocked: true,
      inputList: [
        {
          label: strLang("name"),
          value: selectedTer.name,
          style: { width: 300 },
          change: (e) => updateTer({ name: e.target.value }),
        },
        {
          label: strLang("map"),
          value: selectedTer.tile,
          style: { width: 300 },
          select: tileList.map((e) => {
            return { value: e, label: strLang(e, "tileNames") };
          }),
          change: (tile) => updateTer({ tile }),
        },
        {
          label: strLang("group"),
          value: selectedTer.group,
          style: { width: 300 },
          select: [
            {
              value: 0,
              label: strLang("withoutGroup"),
            },
            ...terGroups.map((e) => {
              return { value: e.code, label: e.name };
            }),
          ],
          change: (group) => updateTer({ group }),
        },
        {
          label: strLang("territoryAlert"),
          textArea: true,
          style: { width: 300 },
          value: selectedTer.descrip,
          change: (e) => updateTer({ descrip: e.target.value }),
        },
      ],
      buttons: [
        {
          label: strLang("save"),
          func: () => {
            if (selectedTer.name.trim().length === 0) {
              setOpen("nameEmpty");
            } else {
              funcUpdateCheck("UPDATETER", {
                code: selectedTer.id,
                group: localStorage.getItem("code2"),
                value: selectedTer.name.trim().replace('"', "ʺ"),
                tile: selectedTer.tile.value,
                descrip:
                  typeof selectedTer.descrip === "string"
                    ? selectedTer.descrip.trim().replace('"', "ʺ")
                    : "",
                terGroup: selectedTer.group.value,
              });
            }
          },
          width: 80,
        },
        {
          label: strLang("cancel"),
          func: closeMsg,
          width: 80,
          color: colorsList.darkGrey,
        },
      ],
    },
    records: {
      label: selectedTer.name,
      table: selectedTer.table,
      buttons: [
        {
          label: strLang("close"),
          func: closeMsg,
          width: 80,
        },
      ],
    },
    editGroup: {
      title: strLang("groupsTerritories"),
      inputList: [
        {
          label: strLang("group"),
          style: { width: 300 },
          value: {
            value: selectedTer.id,
            label: selectedTer.id ? selectedTer.name : strLang("newGroup"),
          },
          select: [
            { value: false, label: strLang("newGroup") },
            ...terGroups.map((e) => {
              return { value: e.code, label: e.name };
            }),
          ],
          change: ({ value }) => {
            if (value > 0) {
              updateTer({
                id: value,
                name: terGroups.find((o) => o.code === value).name,
              });
            } else {
              updateTer({ id: false, name: strLang("newGroup") });
            }
          },
        },
        {
          label: strLang("name"),
          value:
            selectedTer.name === strLang("newGroup") ? "" : selectedTer.name,
          style: { width: 300 },
          change: (e) => updateTer({ name: e.target.value }),
        },
      ],
      buttons: [
        {
          label: selectedTer.id ? strLang("update") : strLang("create"),
          func: updateGroupData,
          width: 80,
        },
        selectedTer.id && {
          label: strLang("delete"),
          func: () => {
            setOpen("askDeleteGroup");
          },
          width: 80,
          color: colorsList.red,
        },
        {
          label: strLang("cancel"),
          func: closeMsg,
          width: 80,
          color: colorsList.darkGrey,
        },
      ],
    },
    askDeleteGroup: {
      title: strLang("wantDeleteGroup"),
      label: selectedTer.name,
      buttons: [
        {
          label: strLang("delete"),
          func: deleteGroup,
          width: 80,
          color: colorsList.red,
        },
        {
          label: strLang("cancel"),
          func: closeMsg,
          width: 80,
          color: colorsList.darkGrey,
        },
      ],
    },
    nameEmpty: {
      type: "warning",
      label: strLang("addName"),
      blocked: true,
      buttons: [
        {
          label: strLang("ok"),
          func: () => {
            setOpen(selectedTer.tryAgain);
          },
          width: 80,
        },
      ],
    },
    openWarning: {
      type: "warning",
      title: selectedTer.name,
      label: selectedTer.descrip,
      buttons: [
        {
          label: strLang("close"),
          func: selectedTer.id ? startMap : closeMsg,
          width: 80,
        },
      ],
    },
    loading: { type: "loading" },
    delete: {
      type: "error",
      title: strLang("delTer"),
      label: selectedTer.name,
      buttons: [
        {
          label: strLang("delete"),
          func: () => {
            funcUpdateCheck("TERDEL", { code: selectedTer.id });
          },
          width: 80,
          color: colorsList.red,
        },
        {
          label: strLang("cancel"),
          func: closeMsg,
          width: 80,
          color: colorsList.darkGrey,
        },
      ],
    },
    error: {
      type: "error",
      label: strLang("netWorkError"),
    },
  };

  const menuButtons = [
    {
      title: strLang("new"),
      func: () => editTer(false),
      color: colorsList.green,
      active: isEditor,
    },
    {
      title: msgType.sort.buttons[filter.sort - 1].label,
      func: () => setOpen("sort"),
      active: true,
    },
    {
      title: msgType.status.buttons[filter.status].label,
      func: () => setOpen("status"),
      active: true,
    },
  ];

  const optionsButtons = [
    isEditor && {
      active: true,
      label: strLang("editGroups"),
      onClick: openUpdateGroup,
      color: colorsList.green,
    },
    {
      active: true,
      label: strLang("allGroups"),
      onClick: () => filterMap({ group: -1 }),
      color: [null, -1].includes(filter.group)
        ? colorsList.blue
        : colorsList.darkGrey,
    },
    isEditor && {
      active: true,
      label: strLang("withoutGroup"),
      onClick: () => filterMap({ group: -2 }),
      color: filter.group === -2 ? colorsList.blue : colorsList.darkGrey,
    },
  ];

  const refresh = () => {
    setOpen("loading");
    reloadMap();
  };

  return {
    open,
    closeMsg,
    msgType,
    filterMap,
    list,
    filter,
    askOpenTerritory,
    menuButtons,
    optionsButtons,
    groupScreen,
    switchGroupScreen,
    closeGroupScreen,
    clearText,
    askDelete,
    editTer,
    openRecords,
    refresh,
    setSelectedTer,
    setOpen,
  };
}
